import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DefineRepositoryParams,
  RepositoryAbstract
} from './repository.abstract';

export interface ContentSearchItem {
  id: number;
  type: 'document' | 'post' | 'event' | 'group';
  title: string;
  subtitle?: string;
}

export type ContentSearchRepositoryParams = DefineRepositoryParams<
  ContentSearchItem,
  {
    all: { items: ContentSearchItem[] };
    queryParams: { q: string };
  }
>;

@Injectable({
  providedIn: 'root'
})
export class ContentSearchRepository extends RepositoryAbstract<ContentSearchRepositoryParams> {
  constructor(injector: Injector) {
    super(`content_search`, injector);
  }

  search(q: string): Observable<{ items: ContentSearchItem[] }> {
    return this.findAll({ q });
  }
}
